var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"message-box",staticClass:"message-box"},[_c('img',{attrs:{"src":"image/icon/icon-warning.svg"}}),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.loadingDialogMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }